<template>
  <template v-if="isLoaded">
    <div class="menu-view">

      <div class="farm-window text-window">
        <TextButton class="farm-button" @click="$emit('close')">
          <h3>Exit to Main Menu</h3>
        </TextButton>
        <div style="margin: auto 0;">
          <p style="margin: 0">Heading out? Remember to save first!</p>
        </div>
      </div>

      <HelpCard v-bind:showExitButton="false"></HelpCard>

      <SavesCard :saveSystem="saveSystem"></SavesCard>

    </div>
  </template>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import util from '../../util'
import TextButton from '@/components/ui/TextButton.vue'
import SavesCard from '@/components/SavesCard.vue'
import SaveSystem from '@/SaveSystem'
import PatreonButton from '@/components/ui/PatreonButton.vue'
import { Personality } from "@/employee/Personality"
import { allPersonalities } from "@/employee/Personalities"
import HelpCard from "@/components/HelpCard.vue"

@Options({
  components: {
    SavesCard, HelpCard, TextButton, PatreonButton
  },
  props: {
    saveSystem: Object
  },
  emits: ['close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    util() {
      return util
    },
    window() {
      return window
    },
    allPersonalities(): Personality[] {
      return Object.entries(allPersonalities()).map(value => value[1])
    }
  },
  async created() {
    //let farm = new Farm()
    //await farm.load()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class Menu extends Vue {
  isLoaded = false
  saveSystem!: SaveSystem
}
</script>

<style scoped lang="scss">

.menu-view {
  margin: auto;
  max-width: 1400px;
  height: 87vh;
  max-height: 800px;

  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    "t s"
    "h s";

  @media screen and (max-width: $mobile-width){
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    grid-template-areas:
      "s"
      "t"
      "h";

    max-height: 100vh;
  }
}

.blushing-defeat-button-row {
  grid-template-columns: 1fr !important;
  height: 50px;
  margin-top: auto;
}

.text-window {
  grid-area: t;

  display: grid;
  grid-template-rows: 30px;
  grid-template-columns: 200px 1fr;
  grid-gap: 10px;
}

.help-card {
  grid-area: h;
  //max-height: 100%;
}

.saves-card {
  grid-area: s;
  max-height: 800px;
}

.stat-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: minmax(40px, 1fr);
}

.text-button {
  border: $component-border-style;

  display: table;
  div {
    display: table-cell;
    vertical-align: middle;
  }

  & > h3 {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
}

.credits-block {
  &:first-child {
    h3 {
      margin-top: 0;
    }
  }

  h3 {
    margin-bottom: 5px;
    margin-top: 15px;
  }

  p {
    margin: 0;
  }
}
</style>
